import { render, staticRenderFns } from "./LoginReminder.vue?vue&type=template&id=17127ee4"
import script from "./LoginReminder.vue?vue&type=script&lang=ts"
export * from "./LoginReminder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports